export interface IServiceCategory {
  id: number;
  name: string;
  count?: number;
}

export interface IService {
  id: number;
  name: string;
  description?: string;
  duration: number;
  avatarPath?: string;
  businessProfileId: number;
  category?: IServiceCategory;
  price: IServicePrice;
  serviceCategoryId: number;
  scheduleId?: number;
  toolIds?: number[];
}

export interface IServicePrice {
  id: number;
  priceType: PriceType;
  minAmount?: number;
  maxAmount?: number;
  fixedAmount?: number;
  currencyId: number;
  currencySymbol: string;
  currencySymbolNative: string;
}

export interface IAvailableHours {
  dayId: number;
  end: string;
  id: number;
  start: string;
}

export enum PriceType {
  FixedPrice = "FixedPrice",
  StartingAt= "StartingAt",
  Hourly = "Hourly",
  Free = "Free",
  ContactUs = "ContactUs",
  Range = "Range"
}
